import React, { useState, useEffect } from 'react';
import { supabase } from '../../lib/supabase';
import * as LucideIcons from 'lucide-react';

interface PatientLeadStatusBadgeProps {
  status: string;
}

interface StatusConfig {
  color: string;
  icon: string;
}

export function PatientLeadStatusBadge({ status }: PatientLeadStatusBadgeProps) {
  const [statusConfig, setStatusConfig] = useState<StatusConfig>({
    color: 'gray',
    icon: 'User'
  });

  useEffect(() => {
    // Fetch status configuration from the database
    const fetchStatusConfig = async () => {
      try {
        const { data, error } = await supabase.rpc('get_lead_statuses');
        
        if (error) throw error;
        
        // Find the matching status
        const matchingStatus = data.find((s: any) => 
          s.slug.toLowerCase() === status.toLowerCase()
        );
        
        if (matchingStatus) {
          setStatusConfig({
            color: matchingStatus.color,
            icon: matchingStatus.icon
          });
        }
      } catch (error) {
        console.error('Error fetching status configuration:', error);
      }
    };
    
    fetchStatusConfig();
  }, [status]);

  // Get the icon component
  const IconComponent = LucideIcons[statusConfig.icon as keyof typeof LucideIcons] as React.FC<{ className?: string }> || LucideIcons.User;

  return (
    <span className={`inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-${statusConfig.color}-100 text-${statusConfig.color}-800`}>
      <IconComponent className="h-3 w-3 mr-1" />
      {status.charAt(0).toUpperCase() + status.slice(1)}
    </span>
  );
}